import { Module } from 'vuex';

import actions from './actions';
import mutations from './mutations';

export const state: Store.User.State = {
  settings: {
    lang: 'pt-BR',
  },
  logged: false,
  planId: '',
};

const namespaced = true;

export const user: Module<Store.User.State, RootState> = {
  namespaced,
  state,
  mutations,
  actions,
};
